import Vue from 'vue'
import moment from 'moment'
import numeral from 'numeral'
import store from "../store"

Vue.filter('toNumber', (value, format = '0,0.00') => {
    const number = numeral(value).format(format)

    return number
})

Vue.filter('toCurrency', (value, currency = 'GHS', format = 'en') => {
    const number = parseFloat(value)

    if (typeof number !== "number") {
        return value
    }

    const formatter = new Intl.NumberFormat(format, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
    })

    const money = formatter.format(number)
    const currency_locale = store.getters.currencies(true)

    return money.replace(currency_locale[currency].symbol, `${currency_locale[currency].iso} `)
})

Vue.filter('toPercentage', (value) => {
    const percent = value * 100

    return `${percent.toFixed(2)}%`
})

Vue.filter('toDate', (value, format = 'MM/DD/YYYY') => {
    if (!value) {
        return value
    }

    return moment(String(value)).format(format)
})

Vue.filter('toCalendarDate', (value, format = 'YYYY-MM-DD') => {
    if (!value) {
        return value
    }

    return moment(String(value), format).calendar(
        null, {
            sameDay: "[Today], MMM D",
            lastDay: "[Yesterday], MMM D",
            lastWeek: "[Last] dddd, MMM D",
            sameElse: "MMMM D YYYY"
        }
    )
})

Vue.filter('toAnswer', (value) => {
    return (value) ? "Yes" : "No"
})

Vue.filter('truncate', (value, length = 15, suffix = '...') => {
    return (value.length > length) ? value.substring(0, length) + suffix : value
})


Vue.filter('placeholder', (value, placeholder = 'N/A') => {
    return (!_.isEmpty(value)) ? value : placeholder
})

Vue.filter('toStartCase', (value) => {
    return _.startCase(value)
})
